module.exports = __webpack_public_path__ + "static/screen-classic-laptop-a735bf51d17b99c1f7aabc6ee44388df.png";